export enum DashboardOrganizationTypeEnum {
  Standard = 0,
  Reduced = 1,
  SingleCourse = 2,
}
